import React from 'react';
import { Badge, Cushion, Grid, Rectangle, Shadow, Space } from '@pitchero/react-ui';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import Map from '../map';
import AddressSelector from './address-selector';

const ClubLocations = ({ selectedLocation, setSelectedLocation, locations, club }) => (
  <Shadow>
    <div style={{ overflow: 'hidden', borderRadius: '4px' }}>
      <Space top="medium">
        <Rectangle radius="rounded" fill="white" component="div" style={{ marginTop: '0px' }}>
          <Grid
            className="location-selector-grid"
            columns="minmax(200px,400px) minmax(480px, 966px)"
            areas="'locationSelector map'"
            style={{ minHeight: '290px' }}
            responsive={[
              {
                minWidth: 600,
                maxWidth: 911,
                props: {
                  columns: 'auto',
                  areas: `"map" "locationSelector"`,
                  rows: '307px 1fr',
                },
              },
              {
                minWidth: 0,
                maxWidth: 599,
                props: {
                  columns: 'auto',
                  areas: `"map" "locationSelector"`,
                  rows: '210px 1fr',
                },
              },
            ]}
          >
            <div style={{ gridArea: 'locationSelector' }}>
              <Cushion
                top="xlarge"
                horizontal="xlarge"
                responsive={[{ minWidth: 0, maxWidth: 947, props: { bottom: 'medium' } }]}
              >
                <AddressSelector
                  locations={locations}
                  selectedLocation={selectedLocation}
                  setSelectedLocation={setSelectedLocation}
                />
              </Cushion>
            </div>
            <div style={{ gridArea: 'map' }}>
              <Grid
                className="map-and-shield-grid"
                columns="auto"
                style={{ overflow: 'hidden', maxWidth: '100%', height: '100%' }}
              >
                {selectedLocation &&
                  selectedLocation.lat !== 0 &&
                  selectedLocation.lng !== 0 &&
                  selectedLocation.lat !== null &&
                  selectedLocation.lng !== null && (
                    <Space
                      className="map-shield"
                      component="div"
                      style={{
                        gridArea: ' 1 / 1 / 2 / 2',
                        zIndex: '1',
                        placeSelf: 'center',
                      }}
                      bottom={43}
                    >
                      {selectedLocation && !isEmpty(locations) && (
                        <a
                          href={`https://maps.google.com/maps?z=12&t=m&q=${selectedLocation.lat}+${selectedLocation.lng}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Club Location on Google Maps"
                        >
                          <Badge size={40} />
                        </a>
                      )}
                    </Space>
                  )}
                <Cushion
                  className="map-image"
                  style={{ gridArea: '1 / 1 / 2 / 2' }}
                  responsive={[{ maxWidth: 620, props: { minHeight: '217px' } }]}
                  component="div"
                >
                  <Map
                    height={353}
                    width={966}
                    lat={selectedLocation ? selectedLocation.lat : null}
                    lng={selectedLocation ? selectedLocation.lng : null}
                    name={`${club.name} ${selectedLocation ? selectedLocation.name : ''}`}
                    objectFit="cover"
                    objectPosition="center"
                    style={{
                      display: 'block',
                    }}
                    responsive={[
                      {
                        maxWidth: 599,
                        props: {
                          height: '210px',
                          width: '100%',
                        },
                      },
                      {
                        minWidth: 600,
                        props: {
                          height: '100%',
                          width: '100%',
                        },
                      },
                    ]}
                  />
                </Cushion>
              </Grid>
            </div>
          </Grid>
        </Rectangle>
      </Space>
    </div>
  </Shadow>
);

ClubLocations.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selectedLocation: PropTypes.shape().isRequired,
  club: PropTypes.shape().isRequired,
  setSelectedLocation: PropTypes.func.isRequired,
};

export default ClubLocations;
